import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "documents-container" };
const _hoisted_3 = { class: "document-content" };
const _hoisted_4 = { class: "d-flex align-center" };
const _hoisted_5 = { class: "flex-grow-1" };
const _hoisted_6 = { class: "docCol" };
const _hoisted_7 = { class: "doc-date" };
import { ref, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useDocuments } from '@/composables/useDocuments';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import SwipeActionsContainer from './elements/SwipeActionsContainer.vue';
import MGButton from './elements/MGButton.vue';
import MGDialog from './elements/MGDialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UnprocessedDocumentsPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getDocuments, deleteDocument: apiDeleteDocument, updateDocument } = useDocuments();
        const processingDocument = ref(null);
        const showDeleteDialog = ref(false);
        const documentToDelete = ref(null);
        const showRenameDialog = ref(false);
        const documentToRename = ref(null);
        function onLoad() {
            getCustomer();
            getDocuments(() => {
                state.documents = state.documents.filter((doc) => !doc.processedOk);
                console.log(state.documents, 'documents');
            });
        }
        function openDocument({ item }) {
            console.log(item, 'open document');
            if (item.url) {
                window.open(item.url, '_blank');
            }
        }
        function handleActionClick({ item, action }) {
            switch (action.type) {
                case 'edit':
                    openRenameDialog({ item });
                    break;
                case 'delete':
                    confirmDelete({ item });
                    break;
            }
        }
        function confirmDelete({ item }) {
            documentToDelete.value = item;
            showDeleteDialog.value = true;
        }
        function openRenameDialog({ item }) {
            documentToRename.value = item;
            showRenameDialog.value = true;
        }
        function deleteDocument() {
            if (documentToDelete.value) {
                apiDeleteDocument(documentToDelete.value.id, () => {
                    state.documents = state.documents.filter((d) => d.id !== documentToDelete.value.id);
                    showDeleteDialog.value = false;
                    documentToDelete.value = null;
                });
            }
        }
        function renameDocument() {
            if (documentToRename.value) {
                console.log(documentToRename.value, 'document to rename');
                updateDocument(documentToRename.value, () => {
                    getDocuments(() => {
                        state.documents = state.documents.filter((doc) => !doc.processedOk);
                    }, true);
                    const docIndex = state.documents.findIndex((d) => d.id === documentToRename.value.id);
                    if (docIndex !== -1) {
                        state.documents[docIndex].name = documentToRename.value.name;
                    }
                    showRenameDialog.value = false;
                });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Unprocessed Documents" }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                (_unref(state).documents)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            (_unref(state).documents.length === 0)
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    class: "mt-4"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createElementVNode("p", { class: "text-center" }, "No unprocessed documents found.", -1)
                                            ])),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createVNode(SwipeActionsContainer, {
                                items: _unref(state).documents,
                                backgroundColor: 'white',
                                mailStyleSwipe: false,
                                actions: [
                                    {
                                        icon: 'mdi-delete',
                                        type: 'delete',
                                        color: 'white',
                                        backgroundColor: 'var(--background-color-alt2)'
                                    },
                                    {
                                        icon: 'mdi-pencil',
                                        type: 'edit',
                                        color: 'grey',
                                        backgroundColor: 'var(--background-color-alt)'
                                    }
                                ],
                                onContentClick: openDocument,
                                onActionClick: handleActionClick
                            }, {
                                default: _withCtx(({ item }) => [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createVNode(_component_v_icon, {
                                                class: "docIcon",
                                                icon: "mdi-file-document-outline"
                                            }),
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                                                _createElementVNode("div", _hoisted_7, _toDisplayString(item.createDateTimeString), 1)
                                            ]),
                                            _createVNode(_component_v_icon, {
                                                size: "small",
                                                color: "grey"
                                            }, {
                                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                    _createTextVNode("mdi-chevron-right")
                                                ])),
                                                _: 1
                                            })
                                        ])
                                    ])
                                ]),
                                _: 1
                            }, 8, ["items"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(MGDialog, {
                    modelValue: showDeleteDialog.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((showDeleteDialog).value = $event)),
                    "max-width": "400",
                    title: "Delete Document"
                }, {
                    content: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("p", null, "Are you sure you want to delete this document?", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            onClick: deleteDocument,
                            text: "Delete"
                        }),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            onClick: _cache[0] || (_cache[0] = ($event) => (showDeleteDialog.value = false)),
                            outline: true,
                            text: "Cancel"
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showRenameDialog.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showRenameDialog).value = $event)),
                    "max-width": "400",
                    title: "Rename Document"
                }, {
                    content: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: documentToRename.value.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((documentToRename.value.name) = $event)),
                            label: "New Name"
                        }, null, 8, ["modelValue"])
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            onClick: renameDocument,
                            text: "Rename"
                        }),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            onClick: _cache[3] || (_cache[3] = ($event) => (showRenameDialog.value = false)),
                            outline: true,
                            text: "Cancel"
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
